import React from "react";
import FourHeadLogo from "../../assets/logos/fourhead-logo.svg";

const Logo: React.FC = () => {
  return (
    <div className="logo">
      <img src={FourHeadLogo} alt="Logo" className="logo__icon" />
    </div>
  );
};

export default Logo;
